function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from "react";
import { Button } from "@material-ui/core";
import { LoadingSpinner } from "../../../../Common/LoadingUI";
import { giftSvg } from "../../../../DealsAndDiscounts/Components/Header/svg";
import { isRewardsVisible } from "../../../../../utils/routing";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function FourthStep(_ref) {
  var _String;
  var checkKycVerificationStatus = _ref.checkKycVerificationStatus,
    checkBankVerificationStatus = _ref.checkBankVerificationStatus,
    setStep = _ref.setStep,
    getUserAccountSummary = _ref.getUserAccountSummary,
    rewardTypeSelected = _ref.rewardTypeSelected,
    closeKYCModal = _ref.closeKYCModal,
    setClaimInProgress = _ref.setClaimInProgress,
    winnreAuth = _ref.winnreAuth;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    loading = _React$useState2[0],
    setLoading = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    rewardLoading = _React$useState4[0],
    setRewardLoading = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    error = _React$useState6[0],
    setError = _React$useState6[1];
  var _React$useState7 = React.useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    details = _React$useState8[0],
    setDetails = _React$useState8[1];
  var claimReward = function claimReward() {
    var _window;
    (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("CashOutConfirmed");
    setRewardLoading(true);
    if (!winnreAuth) {
      setRewardLoading(false);
      setStep(2);
      return;
    }
    winnreAuth({
      method: "POST",
      url: "/winnre/user/customer/claim-rewards"
    }).then(function (res) {
      console.log("CLAIM REWARD", res);
      setRewardLoading(false);
      if ((res === null || res === void 0 ? void 0 : res.status) == "FAILED") {
        setStep(2); // Add code what happens if req fails
        return;
      }
      setClaimInProgress(false);
      setStep(2);
      // UNCOMMENT
      // getUserAccountSummary();

      // console.log('CLAIM REWARD', res);
    });
  };
  var getBankAndAdhaarDetails = function getBankAndAdhaarDetails() {
    setDetails(null);
    setLoading(true);
    setError(false);
    if (!winnreAuth) {
      setError(true);
      setLoading(false);
      return;
    }
    winnreAuth({
      method: "GET",
      url: "/winnre/user/bank-account"
    }).then(function (res) {
      console.log("current bank data", res);
      setDetails(res);
      return winnreAuth({
        method: "GET",
        url: "/winnre/cp/document"
      });
    }).then(function (res) {
      var _find;
      console.log("current KYC data", res);
      var kyc = (_find = (res || []).find(function (doc) {
        return doc.type === "AADHAAR";
      })) === null || _find === void 0 ? void 0 : _find.documentNumber;
      if (kyc) {
        setDetails(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            kycNumber: kyc
          });
        });
      }
      setLoading(false);
    })["catch"](function (err) {
      setError(true);
      setLoading(false);
    });
  };
  React.useEffect(function () {
    getBankAndAdhaarDetails();
  }, []);
  if (rewardTypeSelected) {
    return /*#__PURE__*/_jsxs("div", {
      className: "px-6 flex flex-col justify-center items-center",
      children: [/*#__PURE__*/_jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "191.301",
        height: "219.08",
        viewBox: "0 0 191.301 219.08",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Group_3239",
          "data-name": "Group 3239",
          transform: "translate(-105.85 -265)",
          children: [/*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1530",
            "data-name": "Ellipse 1530",
            cx: "6",
            cy: "6",
            r: "6",
            transform: "translate(112 292)",
            fill: "#fcc71a"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1531",
            "data-name": "Ellipse 1531",
            cx: "4",
            cy: "4",
            r: "4",
            transform: "translate(236 269)",
            fill: "#15519e"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1532",
            "data-name": "Ellipse 1532",
            cx: "6",
            cy: "6",
            r: "6",
            transform: "translate(201 286)",
            fill: "#1cb0bd"
          }), /*#__PURE__*/_jsx("path", {
            id: "_9310131_star_sparkle_icon",
            "data-name": "9310131_star_sparkle_icon",
            d: "M20.546,11.913c-.12,0-.083-.363-.913-.442-.049,0-.5-.035-1.251-.154a5.5,5.5,0,0,1-2.735-1.178,4.922,4.922,0,0,1-1.215-1.56,9.264,9.264,0,0,1-.734-2.2,21.969,21.969,0,0,1-.429-4.735c0-.089,0-.207,0-.3a.407.407,0,0,0-.417-.436c-.288-.023-.523.152-.523.353s0,.31,0,.4a26.457,26.457,0,0,1-.264,3.679,9.372,9.372,0,0,1-1.25,3.757,4.72,4.72,0,0,1-2.771,1.963,11.954,11.954,0,0,1-2.991.409c-.863.006-.641.408-.641.408,0,.429.641.51.641.51L6,12.424a10.688,10.688,0,0,1,1.961.3,4.884,4.884,0,0,1,2.351,1.314A6.607,6.607,0,0,1,11.786,16.9a17.965,17.965,0,0,1,.524,3.466c.062.812.071,1.636.087,2.358,0,0,.03.287.414.275s.4-.275.4-.275a24.22,24.22,0,0,1,.512-5.653A6.163,6.163,0,0,1,15.452,13.8,4.8,4.8,0,0,1,17.4,12.728a5.6,5.6,0,0,1,.88-.218,5.781,5.781,0,0,1,.751-.114,10.56,10.56,0,0,0,1.27-.153C20.546,12.218,20.4,11.913,20.546,11.913Z",
            transform: "translate(101.454 325.363)",
            fill: "#7700ed"
          }), /*#__PURE__*/_jsx("path", {
            id: "_9310131_star_sparkle_icon-2",
            "data-name": "9310131_star_sparkle_icon",
            d: "M20.546,11.913c-.12,0-.083-.363-.913-.442-.049,0-.5-.035-1.251-.154a5.5,5.5,0,0,1-2.735-1.178,4.922,4.922,0,0,1-1.215-1.56,9.264,9.264,0,0,1-.734-2.2,21.969,21.969,0,0,1-.429-4.735c0-.089,0-.207,0-.3a.407.407,0,0,0-.417-.436c-.288-.023-.523.152-.523.353s0,.31,0,.4a26.457,26.457,0,0,1-.264,3.679,9.372,9.372,0,0,1-1.25,3.757,4.72,4.72,0,0,1-2.771,1.963,11.954,11.954,0,0,1-2.991.409c-.863.006-.641.408-.641.408,0,.429.641.51.641.51L6,12.424a10.688,10.688,0,0,1,1.961.3,4.884,4.884,0,0,1,2.351,1.314A6.607,6.607,0,0,1,11.786,16.9a17.965,17.965,0,0,1,.524,3.466c.062.812.071,1.636.087,2.358,0,0,.03.287.414.275s.4-.275.4-.275a24.22,24.22,0,0,1,.512-5.653A6.163,6.163,0,0,1,15.452,13.8,4.8,4.8,0,0,1,17.4,12.728a5.6,5.6,0,0,1,.88-.218,5.781,5.781,0,0,1,.751-.114,10.56,10.56,0,0,0,1.27-.153C20.546,12.218,20.4,11.913,20.546,11.913Z",
            transform: "translate(276.604 325.363)",
            fill: "#7700ed"
          }), /*#__PURE__*/_jsx("circle", {
            id: "Ellipse_1536",
            "data-name": "Ellipse 1536",
            cx: "4",
            cy: "4",
            r: "4",
            transform: "translate(171 265)",
            fill: "red"
          }), /*#__PURE__*/_jsx("path", {
            id: "_9310131_star_sparkle_icon-3",
            "data-name": "9310131_star_sparkle_icon",
            d: "M26.545,16c-.164,0-.114-.5-1.252-.606-.067,0-.692-.048-1.715-.212a7.541,7.541,0,0,1-3.75-1.616,6.751,6.751,0,0,1-1.667-2.14,12.705,12.705,0,0,1-1.006-3.012,30.13,30.13,0,0,1-.589-6.494c0-.122.006-.284.006-.408A.559.559,0,0,0,16,.915c-.4-.032-.717.209-.717.484s0,.425,0,.554A36.285,36.285,0,0,1,14.925,7a12.854,12.854,0,0,1-1.714,5.152,6.473,6.473,0,0,1-3.8,2.692,16.4,16.4,0,0,1-4.1.561c-1.183.008-.879.559-.879.559,0,.589.879.7.879.7l1.281.039a14.658,14.658,0,0,1,2.689.409,6.7,6.7,0,0,1,3.224,1.8,9.062,9.062,0,0,1,2.027,3.925,24.639,24.639,0,0,1,.718,4.753c.085,1.114.1,2.244.119,3.234,0,0,.041.394.568.378s.552-.378.552-.378a33.217,33.217,0,0,1,.7-7.753,8.452,8.452,0,0,1,2.37-4.477,6.584,6.584,0,0,1,2.667-1.476,7.686,7.686,0,0,1,1.208-.3,7.929,7.929,0,0,1,1.03-.157,14.483,14.483,0,0,0,1.742-.209C26.545,16.418,26.339,16,26.545,16Z",
            transform: "translate(239.454 291.219)",
            fill: "#fcc71a"
          }), /*#__PURE__*/_jsx("path", {
            id: "_9310131_star_sparkle_icon-4",
            "data-name": "9310131_star_sparkle_icon",
            d: "M26.545,16c-.164,0-.114-.5-1.252-.606-.067,0-.692-.048-1.715-.212a7.541,7.541,0,0,1-3.75-1.616,6.751,6.751,0,0,1-1.667-2.14,12.705,12.705,0,0,1-1.006-3.012,30.13,30.13,0,0,1-.589-6.494c0-.122.006-.284.006-.408A.559.559,0,0,0,16,.915c-.4-.032-.717.209-.717.484s0,.425,0,.554A36.285,36.285,0,0,1,14.925,7a12.854,12.854,0,0,1-1.714,5.152,6.473,6.473,0,0,1-3.8,2.692,16.4,16.4,0,0,1-4.1.561c-1.183.008-.879.559-.879.559,0,.589.879.7.879.7l1.281.039a14.658,14.658,0,0,1,2.689.409,6.7,6.7,0,0,1,3.224,1.8,9.062,9.062,0,0,1,2.027,3.925,24.639,24.639,0,0,1,.718,4.753c.085,1.114.1,2.244.119,3.234,0,0,.041.394.568.378s.552-.378.552-.378a33.217,33.217,0,0,1,.7-7.753,8.452,8.452,0,0,1,2.37-4.477,6.584,6.584,0,0,1,2.667-1.476,7.686,7.686,0,0,1,1.208-.3,7.929,7.929,0,0,1,1.03-.157,14.483,14.483,0,0,0,1.742-.209C26.545,16.418,26.339,16,26.545,16Z",
            transform: "translate(144.529 291.219)",
            fill: "#4d78eb"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6070",
            "data-name": "Path 6070",
            d: "M-11190.579,17451.926l-27.5-31.309-5.526-9.254-2.683-11.592,1.334-9.434,3.546-10.316,5.959-8.4,7.865-6.645,7.787-3.41,9.223-2.551,11.415,1.176,13.279,4.785,11.147,12.271,5.037,13.086v17.764l-5.037,9.549-11.147,13.715-17.968,20.561,4.688,9.4h-15.9Z",
            transform: "translate(11391 -17051)",
            fill: "#fff"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6071",
            "data-name": "Path 6071",
            d: "M-11147.15,17490.154l4.808-9.684-28.34-32.51-1.731-8.109,11.523-14.168,7.274-8.689,3.487-8.184,1.111-6.693v-13.4l5.654-1.4h7.257l7.1,1.4,7.5,2.543,6.737,4.465,3.814,4.2,4.043,5.3,2.776,6.676,3.015,10.092v8.975l-3.015,8.875-2.776,6.605-6.444,7.441-8.15,9.33-7.5,7.379-5.061,6.211-2.035,3.652,4.569,8.742Z",
            transform: "translate(11391 -17051)",
            fill: "#da867d"
          }), /*#__PURE__*/_jsx("path", {
            id: "Path_6072",
            "data-name": "Path 6072",
            d: "M-11226.293,17490.154h-15.482l5.247-9.58-28.694-32.83-4.191-8.885-2.418-12.41v-9.17l4.271-8.361,4.4-7.463,6.458-6.721,8.384-4.6,8.374-2.031,5.316-1.238h8.339l1.777,1.238-1.777,8.793v5.979l1.777,6.041,4,8.361,4.156,5.434,4.839,5.678,3.136,3.525,4.457,4.389,5.24,6.277-6.377,8.77-25.8,29.223Z",
            transform: "translate(11391 -17051)",
            fill: "#69aef8"
          }), /*#__PURE__*/_jsxs("g", {
            id: "Balloons",
            transform: "translate(46.493 248.09)",
            children: [/*#__PURE__*/_jsx("path", {
              id: "Path_6061",
              "data-name": "Path 6061",
              d: "M155.3,349.45a.929.929,0,0,0-.929.929V389.62a.929.929,0,1,0,1.858,0V350.379A.929.929,0,0,0,155.3,349.45Z",
              transform: "translate(-44.379 -155.059)",
              fill: "#1e247e",
              stroke: "#1e247e",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6062",
              "data-name": "Path 6062",
              d: "M357.679,349.45a.929.929,0,0,0-.929.929V389.62a.929.929,0,1,0,1.858,0V350.379A.929.929,0,0,0,357.679,349.45Z",
              transform: "translate(-152.768 -155.059)",
              fill: "#1e247e",
              stroke: "#1e247e",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6063",
              "data-name": "Path 6063",
              d: "M254.929,289.557a.929.929,0,0,0-.929.929v67.057a.929.929,0,1,0,1.858,0V290.486A.929.929,0,0,0,254.929,289.557Z",
              transform: "translate(-97.738 -122.982)",
              fill: "#1e247e",
              stroke: "#1e247e",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6064",
              "data-name": "Path 6064",
              d: "M418.957,204.462a26.869,26.869,0,0,1-.762,6.245.929.929,0,0,0,1.805.44,28.735,28.735,0,0,0,.814-6.677.929.929,0,0,0-.925-.933h0a.929.929,0,0,0-.929.925Z",
              transform: "translate(-185.662 -76.912)",
              fill: "#fff",
              stroke: "#fff",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6065",
              "data-name": "Path 6065",
              d: "M385.17,157.74a29.409,29.409,0,0,0-27.491-17.81.929.929,0,1,0,0,1.858,27.6,27.6,0,0,1,25.8,16.711,30.53,30.53,0,0,1,1.564,4.335.929.929,0,0,0,1.791-.495A32.386,32.386,0,0,0,385.17,157.74Z",
              transform: "translate(-152.768 -42.846)",
              fill: "#fff",
              stroke: "#fff",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6066",
              "data-name": "Path 6066",
              d: "M317.139,143.537h0a.929.929,0,0,0-.929.925,26.881,26.881,0,0,1-.762,6.245.929.929,0,0,0,1.805.439,28.74,28.74,0,0,0,.814-6.677A.929.929,0,0,0,317.139,143.537Z",
              transform: "translate(-130.632 -44.778)",
              fill: "#14897b",
              stroke: "#14897b",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6067",
              "data-name": "Path 6067",
              d: "M283.184,103.516a.93.93,0,0,0,.9-1.176,32.386,32.386,0,0,0-1.66-4.6,29.409,29.409,0,0,0-27.491-17.81.929.929,0,0,0,0,1.858,27.6,27.6,0,0,1,25.8,16.711,30.535,30.535,0,0,1,1.564,4.335A.929.929,0,0,0,283.184,103.516Z",
              transform: "translate(-97.738 -10.711)",
              fill: "#14897b",
              stroke: "#14897b",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("circle", {
              id: "Ellipse_1537",
              "data-name": "Ellipse 1537",
              cx: "2.747",
              cy: "2.747",
              r: "2.747",
              transform: "translate(158.814 93.361) rotate(-45)",
              fill: "#14897b",
              stroke: "#14897b",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("circle", {
              id: "Ellipse_1538",
              "data-name": "Ellipse 1538",
              cx: "2.747",
              cy: "2.747",
              r: "2.747",
              transform: "translate(148.38 91.32) rotate(-13.282)",
              fill: "#14897b",
              stroke: "#14897b",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6068",
              "data-name": "Path 6068",
              d: "M253.433,144.193a.93.93,0,0,0-1.279.3,14.3,14.3,0,0,1-24.329,0,.929.929,0,1,0-1.58.977,16.154,16.154,0,0,0,27.489,0A.929.929,0,0,0,253.433,144.193Z",
              transform: "translate(-82.799 -45.055)",
              fill: "#14897b",
              stroke: "#14897b",
              "stroke-width": "1"
            }), /*#__PURE__*/_jsx("path", {
              id: "Path_6069",
              "data-name": "Path 6069",
              d: "M240.879,111.1A38.961,38.961,0,0,0,204.91,87.8a40.809,40.809,0,0,0-9.687,1.155,40.785,40.785,0,0,0-2.065-5.72,39.412,39.412,0,0,0-71.937,0,40.836,40.836,0,0,0-1.98,5.411,41.046,41.046,0,0,0-8.323-.846,39.412,39.412,0,0,0-29.407,65.651l25.418,28.486-6.02,10.428h20.018l-6.02-10.427,25.418-28.486a42,42,0,0,0,2.88-3.607.929.929,0,1,0-1.514-1.077,40.166,40.166,0,0,1-2.752,3.446L112.628,181.7l5.083,8.8H104.128l5.083-8.8L82.9,152.21A37.554,37.554,0,0,1,110.92,89.653a39.138,39.138,0,0,1,7.853.79,38.883,38.883,0,0,0,9.01,35.139L153.2,154.067l-6.02,10.428H167.2l-6.02-10.427L186.6,125.582a38.883,38.883,0,0,0,9.082-34.828,38.9,38.9,0,0,1,9.232-1.1,37.554,37.554,0,0,1,28.021,62.557L206.619,181.7l5.083,8.8H198.119l5.083-8.8L176.89,152.21a39.988,39.988,0,0,1-3.018-3.824.929.929,0,1,0-1.527,1.059,41.818,41.818,0,0,0,3.158,4l25.418,28.486-6.02,10.428H214.92L208.9,181.933l25.418-28.486a38.961,38.961,0,0,0,6.561-42.351Zm-55.667,13.248L158.9,153.833l5.083,8.8H150.4l5.083-8.8L129.17,124.345a37.554,37.554,0,1,1,56.041,0Z",
              fill: "#1e247e",
              stroke: "#1e247e",
              "stroke-width": "1"
            })]
          })]
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-2 font-medium",
        children: "Congratulations, you have successfully selected your rewards!"
      })]
    });
  }
  return loading ? /*#__PURE__*/_jsx(LoadingSpinner, {}) : !loading && details ? /*#__PURE__*/_jsxs("div", {
    className: "px-3 md:px-8 py-5",
    children: [/*#__PURE__*/_jsxs("h2", {
      children: ["Your Aadhar number is", " ", /*#__PURE__*/_jsx("span", {
        className: "font-semibold",
        children: "XXXXXXXX" + ((_String = String(details.kycNumber || "")) === null || _String === void 0 ? void 0 : _String.substring(7, 11))
      })]
    }), /*#__PURE__*/_jsxs("h2", {
      children: ["Your bank account number is", " ", /*#__PURE__*/_jsxs("span", {
        className: "font-semibold",
        children: [" ", details.accountNumber, " "]
      })]
    }), /*#__PURE__*/_jsxs("h2", {
      children: ["Bank account beneficiary name is", " ", /*#__PURE__*/_jsx("span", {
        className: "font-semibold uppercase",
        children: details.beneficiaryName
      }), " "]
    }), /*#__PURE__*/_jsxs("div", {
      className: "mt-4 flex flex-wrap gap-x-3",
      children: [/*#__PURE__*/_jsx("button", {
        className: "w-full md:w-auto bg-primary text-white rounded font-bold px-2 h-10 mt-3",
        onClick: function onClick() {
          return checkKycVerificationStatus(true);
        },
        children: "Update KYC"
      }), /*#__PURE__*/_jsx("button", {
        className: "w-full md:w-auto bg-primary text-white rounded font-bold px-2 h-10 mt-3",
        onClick: function onClick() {
          return checkBankVerificationStatus({
            forceInitate: true
          });
        },
        children: "Update Bank Account"
      }), /*#__PURE__*/_jsx("button", {
        className: "w-full md:w-auto bg-primary text-white rounded font-bold px-2 h-10 mt-3",
        onClick: function onClick() {
          return claimReward();
        },
        children: rewardLoading ? "loading" : "I Confirm"
      })]
    }), isRewardsVisible && /*#__PURE__*/_jsxs("div", {
      onClick: closeKYCModal,
      className: "flex p-4 border-2 rounded-xl mt-7 cursor-pointer",
      children: [giftSvg, /*#__PURE__*/_jsxs("div", {
        className: "ml-2",
        children: [/*#__PURE__*/_jsx("h1", {
          className: "font-semibold",
          children: "Want to claim the whole amount?"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm",
          children: "Redeem your reward at our exclusive store"
        })]
      })]
    })]
  }) : /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Button, {
      onClick: function onClick() {
        return getBankAndAdhaarDetails();
      },
      children: "Try Again"
    })
  });
}
export default FourthStep;